import { useEventBus } from "@vueuse/core";
const campaignChangeEventBusKey = Symbol();
export const campaignChangeEvent = useEventBus(campaignChangeEventBusKey);
const campaignArchiveEventBusKey = Symbol();
export const campaignArchiveEvent = useEventBus(campaignArchiveEventBusKey);
const deprecatedCampaignDraftPublishedEventBusKey = Symbol();
export const deprecatedCampaignDraftPublishedEvent = useEventBus(deprecatedCampaignDraftPublishedEventBusKey);
const deprecatedCampaignDraftDiscardedEventBusKey = Symbol();
export const deprecatedCampaignDraftDiscardedEvent = useEventBus(deprecatedCampaignDraftDiscardedEventBusKey);
